export default {
  methods: {
    submitPhotodeskForm: function () {
      var self = this

      const url = '/photodesk/session/add'

      var form = document.getElementById('addSessionForm')
      let data = new FormData(form)

      for (var i = 0; i < self.selectedUsers.length; i++) {
        var contributor = JSON.stringify(self.selectedUsers[i])
        data.append('contributors[]', contributor)
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'Session created',
            show: true
          })
          self.refreshTopBar()
          self.$router.push('/photodesk/sessions/' + response.data.session.id_photodesk_session)
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data.error) || 'Something went wrong',
            show: true
          })
        })
    },

    submitCopydeskForm: function () {
      var self = this

      const url = '/copydesk/session/add'

      var form = document.getElementById('addSessionForm')
      let data = new FormData(form)

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'Session created',
            show: true
          })
          self.refreshTopBar()
          self.$router.push('/copydesk/sessions/' + response.data.session.type + '/' + response.data.session.id_copydesk_session)
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data.error) || 'Something went wrong',
            show: true
          })
        })
    },

    submitPretouchdeskForm: function () {
      var self = this

      const url = '/pretouchdesk/sessions/add'
      const data = {
        method: 'fifo'
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'Session created',
            show: true
          })
          self.refreshTopBar()
          self.$router.push('/pretouchdesk/sessions/' + response.data.session.id_pretouchdesk_session + '/add')
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data.error) || 'Something went wrong',
            show: true
          })
        })
    },

    submitRetouchdeskForm: function () {
      var self = this

      const url = '/retouchdesk/sessions/add'
      const data = {
        method: 'fifo'
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'Session created',
            show: true
          })
          self.refreshTopBar()
          self.$router.push('/retouchdesk/sessions/' + response.data.session.id_retouchdesk_session + '/add')
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data.error) || 'Something went wrong',
            show: true
          })
        })
    },

    submitCopyTemplateFormAdd: function () {
      var self = this

      const url = '/copydesk/templates/add'

      var form = document.getElementById('addCopyTemplate')
      let data = new FormData(form)

      for (var i = 0; i < self.headers.length; i++) {
        var header_data = JSON.stringify(self.headers[i])
        data.append('template_headers[]', header_data)
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'Template created',
            show: true
          })
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data.error) || 'Something went wrong',
            show: true
          })
        })
    },

    submitCopyTemplateFormUpdate: function () {
      var self = this

      const url = '/copydesk/templates/update'

      var form = document.getElementById('addCopyTemplate')
      let data = new FormData(form)

      for (var i in self.templateData) {
        data.append(i, self.templateData[i])
      }
      data.append('template_headers[]', '')
      for (var i = 0; i < self.headers.length; i++) {
        var header_data = JSON.stringify(self.headers[i])
        data.append('template_headers[]', header_data)
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'Template updated',
            show: true
          })
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data.error) || 'Something went wrong',
            show: true
          })
        })
    },

    submitCompletionRuleForm: function () {
      var self = this

      const url = '/orgdesk/completionrule/add'

      var form = document.getElementById('addCompletionRule')
      let data = new FormData(form)

      for (var i = 0; i < self.required_sessions.length; i++) {
        if (self.required_sessions[i].selected == true) {
          data.append('required_session[]', self.required_sessions[i].name)
        }
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'Rule created',
            show: true
          })
          self.formMode = 'view'
          self.getRules()
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data.error) || 'Something went wrong',
            show: true
          })
        })
    },

    submitStyleGuideForm: function () {
      var self = this

      const url = '/orgdesk/styleguide/add'

      var form = document.getElementById('addStyleGuide')
      let data = new FormData(form)

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'Guide created',
            show: true
          })
          self.formMode = 'view'
          self.getRules()
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data.error) || 'Something went wrong',
            show: true
          })
        })
    },

    submitProjectdeskForm: function () {
      var self = this

      const url = '/projectdesk/project/add'

      var form = document.getElementById('addSessionForm')
      let data = new FormData(form)

      for (var i = 0; i < self.selectedUsers.length; i++) {
        var contributor = JSON.stringify(self.selectedUsers[i])
        data.append('contributors[]', contributor)
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'Project created',
            show: true
          })
          self.refreshTopBar()
          self.$router.push('/projectdesk/projects/' + response.data.session.id_projectdesk_project)
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data.error) || 'Something went wrong',
            show: true
          })
        })
    },

    refreshTopBar () {
      var self = this
      self.$http.get('/auth/profile')
        .then(function (response) {
          self.$store.dispatch('updateUser', response.data)
          self.$store.dispatch('updateOpenSessions', response.data.open_sessions)
          self.$store.dispatch('updateClientVariables', response.data.variables)
        })
    }

  }
}
